/* global pintrk */
import createAdapter from './createAdapter'
export const pinterest = createAdapter(
  () => !navigator.userAgent.match('DisableForTesting') && !!window.pintrk,
  {
    page() {
      pintrk('page')
    },
    track(event) {
      pintrk('track', event)
    },
  }
)
